(function () {
  var rutas = [
    '/collections/cinco-jotas',
    '/pages/antonio-romero-iberico-shoulder-ham-semi-bone-in-carving-kits',
    '/pages/corporate-christmas-gifts',
    '/pages/b2c-2026-christmas',
    '/pages/arc-iberico-imports-black-friday-cyber-monday-sale'
  ];

  var path = decodeURIComponent(location.pathname).toLowerCase().replace(/\/+$/, '');
  var ocultar = rutas.some(function (r) {
    r = '/' + r.toLowerCase().replace(/^\/+/, '').replace(/\/+$/, '');
    return path === r || path.slice(-r.length) === r;
  });

  console.log('[loyalty] path:', path, '| ocultar:', ocultar);
  if (!ocultar) return;

  var style = document.createElement('style');
  style.textContent =
    'one-loyalty-widget,[id*="one-loyalty"],[class*="one-loyalty"]' +
    '{display:none!important;visibility:hidden!important;pointer-events:none!important}';
  document.head.appendChild(style);

  function quitar() {
    document.querySelectorAll('one-loyalty-widget').forEach(function (el) {
      el.remove();
    });
  }
  quitar();
  new MutationObserver(quitar).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();